// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Strikethrough = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Strikethrough = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Strikethrough = _exports.Strikethrough = function Strikethrough(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M12.744 7.182a2 2 0 0 0-.933-1.509q-.817-.537-2.007-.537-.87 0-1.521.282-.645.28-1.01.773a1.85 1.85 0 0 0-.358 1.119q0 .525.25.9.255.372.651.621.396.243.831.403.435.153.799.249l1.33.358q.51.135 1.137.37.633.237 1.208.646.582.403.96 1.036.375.633.376 1.553 0 1.061-.556 1.918-.55.855-1.61 1.361-1.056.505-2.564.505-1.406 0-2.435-.454-1.023-.453-1.61-1.265-.583-.812-.66-1.886H6.66q.064.741.499 1.227a2.7 2.7 0 0 0 1.112.716q.677.23 1.457.23.908 0 1.63-.294.723-.3 1.144-.83.422-.538.422-1.253 0-.652-.364-1.062a2.7 2.7 0 0 0-.959-.664q-.594-.256-1.285-.448l-1.61-.46q-1.535-.441-2.43-1.26-.894-.818-.894-2.14 0-1.1.594-1.918.601-.825 1.61-1.279 1.017-.46 2.27-.46 1.266 0 2.25.454.984.447 1.56 1.227.582.78.613 1.77z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M4 11.107h11.48v1.227H4z"
    }));
  };
});
